import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-sysparams',
  templateUrl: './sysparams.component.html',
  styleUrls: ['./sysparams.component.css']
})
export class SysparamsComponent extends BaseCrudComponent {

  	translations: any;
    listTypes: any;
    loadingRequired: any;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.read_url = 'SystemParameter/All';
        this.create_url = '';
        this.update_url = 'SystemParameter/Update';
        this.delete_url = '';
        this.search_fields = ['field', 'id', 'value'];
        
        this.listTypes = [];
        this.loadingRequired = false;

        this.reload.subscribe(val => {
            if (val) {
                super.clearData();
                this.getList();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
            });
    }

    openUpdateModal(content: any, obj: any) {
    	super.openUpdateModal(content, obj);
    }

    validateUpdateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'id': new FormControl(fields.id, [Validators.required]),
            'value': new FormControl(fields.value, [Validators.required])
        });

        return mygroup.valid;
    }

    public updateItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }
        
        validated = this.validateUpdateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.id = form.id;
        to.value = form.value;

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if (x.status) {
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else {
                Swal.fire(x.message, '', 'error');
                //this.closeModal(content);
            }
        });
    }

}
